import React, { useEffect, useState } from "react";
import Teams from "../../api/team";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import axios from "axios";
import tImg from '../../images//team/61_result.webp'

const TeamSection = (props) => {
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`https://api.rashtechinfo.com/activeTeam`)
        setTeams(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBlogs();
  }, []);
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    // <section className="team_section xb-hidden section_space">
    //   <div className="container">
    //     <div className="heading_block text-center">
    //       <div className="heading_focus_text">
    //         <span className="badge bg-secondary text-white">Our Expert</span>
    //         Team Members
    //       </div>
    //       <h2 className="heading_text mb-0">Top Skilled Experts</h2>
    //     </div>

    //     <div className="team_carousel">
    //       <Swiper
    //         loop={true}
    //         spaceBetween={30}
    //         allowTouchMove={true}
    //         centeredSlides={true}
    //         pagination={{ clickable: true }}
    //         speed={800}
    //         breakpoints={{
    //           576: {
    //             slidesPerView: 2,
    //           },
    //           1025: {
    //             slidesPerView: 3,
    //           },
    //         }}
    //       >
    //         {teams.slice(0, 6).map((team, tm) => (
    //           <SwiperSlide key={tm}>
    //             <div className="team_block">
    //               <div className="team_member_image">
    //                 <span
    //                   onClick={ClickHandler}
    //                   className="image_wrap"
    //                   aria-label="Team Details Button"
    //                 >
    //                   <img src={`https://api.rashtechinfo.com/uploads/${team.image}`} alt="" />
    //                 </span>
    //               </div>
    //               <div className="team_member_info">
    //                 <h3 className="team_member_name">
    //                   <span
    //                     onClick={ClickHandler}
    //                   >
    //                     {team.name}
    //                   </span>
    //                 </h3>
    //                 <h4 className="team_member_designation">{team.designation}</h4>
    //               </div>
    //             </div>
    //           </SwiperSlide>
    //         ))}
    //       </Swiper>
    //     </div>

    //     <div className="container">
    //       <div className="btns_group pb-0">
    //         <Link className="btn btn-outline-light" to="/team">
    //           <span className="btn_label" data-text="Our All Experts">
    //             Our All Experts
    //           </span>
    //           <span className="btn_icon">
    //             <i className="fa-solid fa-arrow-up-right"></i>
    //           </span>
    //         </Link>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section className="about_section section_space bg-light">
              <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                  <div className="col-lg-6 order-lg-last">
                    <div className="team_cartoon_image">
                      <img src={tImg} alt="Team Cartoon" />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="about_content">
                      <div className="heading_block">
                        <div className="heading_focus_text">
                          Our Dedicated
                          <span className="badge bg-secondary text-white">Team </span>
                        </div>
                        <h2 className="heading_text">
                          Get to Know Our Expert RashTech Team
                        </h2>
                        <p className="heading_description mb-0">
                          Get acquainted with the powerhouse behind RashTech – our expert team of professionals dedicated to revolutionizing the IT landscape. Comprising.
                        </p>
                        
                      </div>
                      <Link onClick={ClickHandler} to={'/contact'} className="btn">
                        <span className="btn_label" data-text="Talk to an Expart">Talk to an Expart</span>
                        <span className="btn_icon">
                          <i className="fa-solid fa-arrow-up-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
  );
};

export default TeamSection;
